module.exports = __webpack_public_path__ + "static/media/Aviso.af97b9cb.svg";